import requestAction from '../../utils/requestAction'

export const uploadPreorderHoldFile = (formData: FormData, preoderId: number, handleResponse: (fileId: string) => void) =>
  requestAction('PREORDER_HOLD_UPLOADFILE')(
    `preorders/upload/hold/${preoderId}`,
    'POST',
    formData,
    undefined,
    'file',
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.fileId) })

